import styled from 'styled-components';

export const MeterHealthWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
